import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { useAppDispatch, useAppSelector } from '@/redux/hooks/useAppState'
import {
	isInviteUsersDialogOpen,
	setIsInviteUsersDialogOpen,
} from '@/redux/store/slices/ui/uiSlice'
import { DataSourcesRoutes } from '@/routes/DataSourcesRoutes'
import { LocationsRoutes } from '@/routes/LocationsRoutes'
import SettingsPage from '@/routes/Settings/SettingsPage'
import { SignUpPage } from '@/routes/SignUp'
import { OrdersPage } from '@/routes/Orders'
import { FloatingChatBubble } from '@/components/Inbox/FloatingChatBubble'
import { useChatBubble } from '@/components/Inbox/ChatBubbleProvider'
import { Outlet, Route, Routes } from 'react-router-dom'
import { createPortal } from 'react-dom'

import { GridsRoutes } from '../Grids/GridRoutes'
import { InviteUser } from '../InviteUser'
import { WorkspaceNavigation } from './WorkspaceNavigation/WorkspaceNavigation'

export const WorkspaceContainer = () => {
	const isInviteOpen = useAppSelector(isInviteUsersDialogOpen)
	const dispatch = useAppDispatch()
	const { state, openInbox } = useChatBubble()


	return (
		<SidebarProvider defaultOpen={false}>
			<div className="flex h-screen bg-background w-full">
				<WorkspaceNavigation />
				<SidebarInset className="flex flex-col">
					<div className="flex flex-1 min-h-0">
						<Routes>
							<Route element={<Outlet />}>
								<Route path="orders" element={<OrdersPage />} />
								<Route path="leads" element={<OrdersPage />} /> {/* Temporary redirect */}
								<Route path="grids/*" element={<GridsRoutes />} />
								<Route path="locations/*" element={<LocationsRoutes />} />
								<Route path="settings" element={<SettingsPage />} />
								<Route path="settings/:entity" element={<SettingsPage />} />
								<Route path="settings/:entity/:recordId" element={<SettingsPage />} />
								<Route path="data-sources/*" element={<DataSourcesRoutes />} />
								<Route path="sign-up" element={<SignUpPage />} />
							</Route>
						</Routes>
					</div>
				</SidebarInset>
				<InviteUser
					isOpen={isInviteOpen}
					onCancel={() => dispatch(setIsInviteUsersDialogOpen(false))}
					onSubmit={() => dispatch(setIsInviteUsersDialogOpen(false))}
				/>
				
				{/* Chat Components - Rendered via Portal to document.body for proper stacking context */}
				{state.isVisible && state.mode === 'floating' && createPortal(
					<FloatingChatBubble
						onOpenInbox={openInbox}
					/>,
					document.body
				)}
				
				
			</div>
		</SidebarProvider>
	)
}
